import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseDiscountUpdatedTemplates = [
  {
    id: '-114001',
    language: Language.EN,
    subject: 'Lease discount update',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: discount update on the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Updated discount details:</p>
        <ul>
        <li>Label: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Amount: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Comment: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Start date: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Duration: <strong>{{lvoDuration lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-114002',
    language: Language.FR,
    subject: 'Modification de remise sur le bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: ajustement d'une remise relative au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nouveaux détails de la remise:</p>
        <ul>
        <li>Libellé: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Montant: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Commentaire: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Date de début: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Durée: <strong>{{lvoDuration lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-114003',
    language: Language.NL,
    subject: 'Update op korting',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: update van de korting op uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nieuwe details korting:</p>
        <ul>
        <li>Label: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Bedrag: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Opmerking: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Begindatum: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Duur: <strong>{{lvoDuration lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-114004',
    language: Language.DE,
    subject: 'Aktualisierung des Mietrabatts',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Aktualisierung des Rabatts auf den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Aktualisierte Rabatt-Details:</p>
        <ul>
        <li>Bezeichnung: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Betrag: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Kommentar: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Startdatum: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Dauer: <strong>{{lvoDuration lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
